// extracted by mini-css-extract-plugin
export default {"container":"ResponseResult_container__injYm","title":"ResponseResult_title__H4GgI","subtitle":"ResponseResult_subtitle__W9XkL"};